class ExpertSlider extends HTMLElement {
    constructor() {
        super()
        this.swiper = null
    }

    connectedCallback() {
        const container = this.querySelector('.swiper')
        const prevButton = this.querySelector('[data-swiper-button="left"]')
        const nextButton = this.querySelector('[data-swiper-button="right"]')

        this.swiper = new Swiper(container, {
            slidesPerView: 'auto',
            speed: 400,
            spaceBetween: 16,
            navigation: {
                prevEl: prevButton,
                nextEl: nextButton,
                disabledClass: 'opacity-30 cursor-not-allowed',
            },
            a11y: {
                enabled: true,
            },
            keyboard: {
                enabled: true,
                onlyInViewport: true,
            },
        })
    }

    disconnectedCallback() {
        if (this.swiper) {
            this.swiper.destroy(true, true)
        }
    }
}

customElements.define('expert-slider', ExpertSlider)